export default "__VITE_ASSET__CmxpsLvV__"